import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalMainComponent } from '../../../../modals/modal-main/modal-main.component';
import { UpdateUserEmailComponent } from '../../../../modals/user-modal/update-user-email.component';
import { FirebaseService } from '../../../../service/firebase.service';
import { UserCreationModalComponent } from '../../../../user-creation-modal/user-creation-modal.component';
import { ServerService } from '../../server.service'
import { TranslationPipe } from '../../../../shared/pipes/translation.pipe';
import { SharedService } from '../../../../services/shared.service';
@Component({
  selector: 'app-usermanagement',
  templateUrl: './usermanagement.component.html',
  styleUrls: ['./usermanagement.component.scss']
})
export class UsermanagementComponent implements OnInit, AfterViewInit {
  subsusers: any;
  dialogRef: any;
  noUser: boolean = false;
  listUsers: Array<Object> = [];
  listDevices: Array<any> = [];
  constructor(private _usermanagementService: ServerService, private _shared: SharedService, private dialog: MatDialog, private _firebaseService: FirebaseService, public translation: TranslationPipe) { }

  ngOnInit(): void {


    this.listUsers = this._usermanagementService.getListUsers();
    this._usermanagementService.userObserver.subscribe(d => {
      this.listUsers = d;

      if (this.listUsers.length == 0)
        setTimeout(() => {

          console.log(this.listUsers)
          if (this.listUsers.length == 0)
            this.noUser = true;
        }, 3000)

      console.log(this.listUsers)
    })


    this._firebaseService.getAllDevicesFromUser().then(d => {
      this.listDevices = d;
      console.log(d)
    })
    /* GET BORNE LISTE */



    // console.log(this.listUsers)

  }

  onDeviceChange(user, e) {
    console.log(user, e)



    user.data.assignedDevice = e;
    this._usermanagementService.updateUserData(user.id, user.data);

    /* UPDATE USER ASSGINED DEVICE */




    /* SAVE IN LOCAL ARRAY */

  }

  ngAfterViewInit() {
    console.log(this._shared.getDeviceArray());

  }

  deleteUser(id) {
    if (confirm('Voulez vous supprimer cet utilisateur')) {
      this._usermanagementService.deleteSubUser(id)
    }
    else {

    }

  }

  updateEmailPopUp(oldEmail) {
    let dialogRef = this.dialog.open(UpdateUserEmailComponent, {
      height: '400px',
      width: '600px',
    });


    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this._firebaseService.updateUserEmail(oldEmail, result.email, result.password)
      }

    });


  }

  createSubUsers() {
    this.dialogRef = this.dialog.open(UserCreationModalComponent, {
      width: '30vw',
      height: '40vh',
      data: { type: 'sub' }
    })
  }

}
